module.exports = __webpack_public_path__ + "img/studies_rubicon_biatorbagy_03.063a0700.png";